/**
 *
 * NumberField
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

import TextField from 'components/TextField';

function NumberField(props) {
  const { onChange, ...otherProps } = props;
  return (
    <NumberFormat
      thousandSeparator
      decimalSeparator="."
      decimalScale={2}
      {...otherProps}
      customInput={TextField}
      onValueChange={values => {
        const { value } = values;

        onChange(value);
      }}
    />
  );
}

NumberField.propTypes = {
  onChange: PropTypes.func,
};

export default NumberField;
